import { useState } from "react";
import { useLookupTraductionsQuery } from "../../stores/OkOkStore";
import type { QueryParameters } from "../../types/QueryParameters";
import type { Traductions } from "../../types/Traductions";
import Pager from "../Common/Pager";
import { NavLink } from "react-router";
import { useTrads } from "../../contexts/trads/useTrads";



export default function TraductionsList(){
    const [params,setParams]=useState<QueryParameters>({page:0, order:'', reverse:0});
    
    const { data, error, isLoading } = useLookupTraductionsQuery(params);
    const {translate}=useTrads();
    const setPage=function(page:number){
        setParams({...params,page: page})
    }
    const setOrder=function(order:string,reverse?:number){
        setParams({...params,order:order,reverse:reverse?? 0});
    }
    const setLookup=function(lookup:string){
        const l={"fulltext":lookup}
        setParams({...params,r:{...params.r,...(lookup && l)}});
    }
        return (
 
            error ? (
               <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : data ? (
                <>
                <div>
                    <input type="text" placeholder="search" name="search" onChange={e => { setLookup(e.target.value)} } />
                </div>
                <Pager curpage={data.page} totalpages={data.pages} setter={setPage}></Pager>
                <table className="table">
                <thead className="sticky-top">
                    <tr>
                        <th scope="col" data-sort="name">
                            <div className="table-sort">
                                {translate('name')}
                                <div className={(params.order=='name')?((params.reverse)?'desc':'asc'):undefined}>
                                    <a className='up' onClick={()=>{ setOrder('name',1); }} ><i className="bi"></i></a>
                                    <a className='down' onClick={()=>{ setOrder('name',0); }} ><i className="bi"></i></a>
                                </div>
                            </div>
                            
                        </th>
                        <th scope="col">{translate('fr')}</th>
                        <th scope="col">{translate('nl')}</th>
                        <th scope="col">{translate('en')}</th>
                        <th scope="col">{translate('explication')}</th>
                        <th scope="col"></th>
                        
                    </tr>
                </thead>
                <tbody>
                    {data.data.map((traduction:Traductions) => (

                        <tr key={traduction.id}>
                            <td>{traduction.name}</td>
                            <td>{traduction.value}</td>
                            <td>{traduction.nl}</td>
                            <td>{traduction.en}</td>
                            <td>{traduction.explication}</td>
                            <td>
                                <div className="d-flex">
                                <NavLink to={`/traductions/${traduction.id.toString()}`}>
                                    <span className="visually-hidden">{translate('btn_voir')}</span>
                                    <i className="bi bi-eye-fill"></i>
                                </NavLink>

                                <NavLink to={`/traductions/${traduction.id.toString()}/edit`}>
                                    <span className="visually-hidden">{translate('btn_edit')}</span>
                                    <i className="bi bi-pencil-fill"></i>
                                </NavLink>
                                </div>
                            </td>    
                        </tr>

                    ))}

                </tbody>
                </table>
                <Pager curpage={data.page} totalpages={data.pages} setter={setPage}></Pager>
                
                </>
            ):null
        );
}